import { OnboardingData } from '../../ui/pages/Onboarding';

export namespace OnboardingLS {
  const ONBOARDING_DATA_KEY = 'VENTORY_ONBOARDING_DATA';

  export function setOnboardingData(data: OnboardingData) {
    localStorage.setItem(ONBOARDING_DATA_KEY, data.toJson());
  }

  export function removeOnboardingData() {
    localStorage.removeItem(ONBOARDING_DATA_KEY);
  }

  export function getOnboardingData() {
    const result = localStorage.getItem(ONBOARDING_DATA_KEY);
    if (!result) return;
    return OnboardingData.fromJson(result);
  }

  type OnboardedState = 'DEFAULT' | 'DEMO';
  const ONBOARDED_STATE_KEY = 'VENTORY_ONBOARDED_STATE';

  export function setOnboardedState(value: OnboardedState) {
    localStorage.setItem(ONBOARDED_STATE_KEY, value);
  }

  export function removeOnboardedState() {
    localStorage.removeItem(ONBOARDED_STATE_KEY);
  }

  export function getOnboardedState(): OnboardedState | undefined {
    return localStorage.getItem(ONBOARDED_STATE_KEY) as OnboardedState | undefined;
  }
}
